/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
        'class':'tab-wrap',
        $html:[{
            $type:require('./TabList'),
            $model:'tabList'
        },{
            $slot:'bar'
        },{
            'class':['tab-content',nb.bind('dataReady')],
            $html:[{
                'class':['loading',nb.bind('loadingReady')],
                tag:'img',
                src:'./image/loading.gif',
                style:{
                    width:'70px'
                }

            },{
                $slot:'content'
            }]
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/tab/TabWrap.js
// module id = 49
// module chunks = 1 3 7 8 9 10 12 14 16 18 19 25 26 28 30